import { render, staticRenderFns } from "./NarliFerryboatStatsByPlateGraph.vue?vue&type=template&id=79ee7172&"
import script from "./NarliFerryboatStatsByPlateGraph.vue?vue&type=script&lang=js&"
export * from "./NarliFerryboatStatsByPlateGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports